import { useDroppable } from "@dnd-kit/core";
import React from "react";

import { formatCurrency } from "../lib/format";
import { Opportunity, PipelineStage } from "../types/crm";
import { OpportunityCard } from "./OpportunityCard";

interface KanbanColumnProps {
  stage: PipelineStage;
  opportunities: Opportunity[];
  onEdit?: (opp: Opportunity) => void;
  onDelete?: (opp: Opportunity) => void;
  canModify?: (opp: Opportunity) => boolean;
}

export function KanbanColumn({ stage, opportunities, onEdit, onDelete, canModify }: KanbanColumnProps) {
  const { setNodeRef, isOver } = useDroppable({ id: stage.id });

  const mrrTotal = opportunities.reduce((sum, opp) => sum + Number(opp.mrr_estimated), 0);

  return (
    <div className="flex w-72 flex-shrink-0 flex-col">
      <div
        className={`mb-2 rounded-[10px] px-2 py-1.5 ${
          stage.is_alert ? "bg-[#FFFBEB]" : ""
        }`}
      >
        <p
          className={`text-sm font-semibold ${
            stage.is_alert ? "text-[#92400E]" : "text-slate-800"
          }`}
        >
          {stage.name}{" "}
          <span className={stage.is_alert ? "text-[#B45309]" : "text-slate-400"}>
            ({opportunities.length})
          </span>
        </p>
        <p className={`text-xs ${stage.is_alert ? "text-[#B45309]" : "text-slate-500"}`}>
          {formatCurrency(mrrTotal)}
        </p>
      </div>
      <div
        ref={setNodeRef}
        data-testid={`kanban-column-${stage.id}`}
        className={`flex-1 space-y-2 rounded-[10px] border border-border-subtle p-2 ${
          isOver ? "bg-primary-soft" : "bg-white"
        }`}
      >
        {opportunities.length === 0 && (
          <p className="px-1 py-2 text-xs text-slate-400">Nenhuma oportunidade</p>
        )}
        {opportunities.map((opportunity) => (
          <OpportunityCard
            key={opportunity.id}
            opportunity={opportunity}
            onEdit={onEdit}
            onDelete={onDelete}
            canModify={canModify ? canModify(opportunity) : false}
          />
        ))}
      </div>
    </div>
  );
}
